import { render, staticRenderFns } from "./project-footer.vue?vue&type=template&id=52c2c628&scoped=true&"
import script from "./project-footer.vue?vue&type=script&lang=js&"
export * from "./project-footer.vue?vue&type=script&lang=js&"
import style0 from "./project-footer.vue?vue&type=style&index=0&id=52c2c628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c2c628",
  null
  
)

component.options.__file = "project-footer.vue"
export default component.exports